export default __webpack_public_path__ + "static/media/disaster.abb44b52.jpg";